import React, {
	Component
} from 'react';
import Global from '../../Global';
import './SimPlanFilter.css';

class SimPlanFilter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			items: []
		}
	}
	
	componentDidMount() {
		var url = Global.getAPI("sim-plan-filter");
		fetch(url)
			.then(function (response) {
				if (response.status >= 400) {
					throw new Error('Error API: sim-plan-filter');
				}
				return response.json();
			})
			.then(data => this.setState({
				items:data.items
			}));
	}
	
	filterData(selectData){
		// console.info(selectData);
		var iconOnObj = document.getElementsByClassName("icon-on");
		var iconOffObj = document.getElementsByClassName("icon-off");
		for(var i=0;i<iconOnObj.length;i++){
			iconOnObj[i].setAttribute("class","icon-on hidden");
			iconOffObj[i].setAttribute("class","icon-off");
		}
		
		document.getElementById("icon-on-"+selectData.id).setAttribute("class","icon-on");
		document.getElementById("icon-off-"+selectData.id).setAttribute("class","icon-off hidden");
		
		this.props.handleFilter(selectData)
	}
	
	getIconList(){
		let html = this.state.items.map( (obj,index) => 
			(<div key={index} className="icon-div">
				<img id={"icon-on-"+obj.id} src={encodeURI(obj.iconOn)} className={"icon-on " + (obj.selected === 'true' ? "" : "hidden")}/>
				<img id={"icon-off-"+obj.id} src={encodeURI(obj.iconOff)} className={"icon-off " + (obj.selected === 'false' ? "" : "hidden")} onClick={() => this.filterData(obj)}/>
				<span>{obj.label}</span>
			</div>)
		)
		return html
	}

	render() {
		return ( <div id = "sim-plan-filter" >
				{this.getIconList()}
			</div >
		);
	}
}

export default SimPlanFilter;
